/** Default effects, grouped by their owning presentation concern.
 * Ability-specific effects (including reload_stars) live in VFXAbilityDefs.
 */
import type { VFXEffectConfig } from '../VFXEffectRegistry';
import { DEFAULT_CAST_VFX } from './defaults/CastVFX';
import { DEFAULT_COMBAT_VFX } from './defaults/CombatVFX';
import { DEFAULT_WORLD_VFX } from './defaults/WorldVFX';

export const DEFAULT_VFX_EFFECTS: VFXEffectConfig[] = [
  ...DEFAULT_CAST_VFX,
  ...DEFAULT_COMBAT_VFX,
  ...DEFAULT_WORLD_VFX,
];
